export default __webpack_public_path__ + "static/media/personality-share-yellow.2ee6f4b8.svg";